import { sendEmailVerification } from 'firebase/auth';
import { getApiBaseUrl } from '../config/api';

function getContinueUrl(continuePath = '/league') {
  const path = continuePath.startsWith('/') ? continuePath : `/${continuePath}`;
  return `${window.location.origin}${path}`;
}

function formatVerificationError(error, fallbackMessage) {
  const code = error?.code || '';
  if (code === 'auth/too-many-requests') {
    return 'Too many verification requests from this device. Wait about an hour, check your inbox/spam for an earlier email, or contact support.';
  }
  return error?.message || fallbackMessage;
}

export async function sendVerificationEmail(user, continuePath = '/league') {
  if (!user) {
    throw new Error('You must be signed in to request a verification email.');
  }

  const baseUrl = getApiBaseUrl();
  if (baseUrl) {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${baseUrl.replace(/\/$/, '')}/auth/send-verification-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ continuePath }),
      });

      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        return { method: data.method || 'graph', alreadyVerified: !!data.alreadyVerified };
      }

      const apiMessage = data.error || `Server error (${response.status})`;
      if (response.status === 429) {
        throw new Error(apiMessage);
      }
      throw new Error(apiMessage);
    } catch (error) {
      if (error instanceof Error && !error.code) {
        throw error;
      }
      throw new Error(formatVerificationError(error, 'Failed to send verification email.'));
    }
  }

  try {
    await sendEmailVerification(user, { url: getContinueUrl(continuePath) });
    return { method: 'firebase' };
  } catch (error) {
    throw new Error(formatVerificationError(error, 'Failed to send verification email.'));
  }
}
